import * as ABCya from '@abcya/abcya_phaser';
import gameData from '../../gameData';

export default class Donut
{
    constructor(x,y,displayObj,scene,type)
    {
        this.shape = displayObj.shape;
        this.answer = displayObj.answer;
        this.questionType = type;
        if(this.shape === "Star") y -= 3;
        if(this.shape === "Heart") y += 2;
        this.image = ABCya.Images.addImage(x,y,displayObj.frameName,scene).setScale(gameData.donutScale).setAlpha(0);
        this.row = (y < 541) ? "top" : "bottom";
    
        this.yData = y;

        //gameData.currentDonuts.push(this);

        if(this.shape === "Ring") this.shape = "Round";
        this.selectorFrame = `General UI/Selected_${this.shape}`;

        //this.image.setInteractive();
        this.image.scene.events.on("correct",()=>{
            //this.image.destroy(); 
            this.image.disableInteractive();
        });
        this.image.scene.events.on("cleanDonuts",()=>{
            this.image.destroy(); 
        });
        this.image.on("pointerup",()=>{
            this.image.scene.events.emit(type+"Click",this);
            this.image.scene.custSound.playSoundCustom('click-select-donuts');
        });
    }
}